import React, { useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash-es';
import { MCPUIToolsResultsAsync } from 'site-modules/canvas/components/chat-messages/ai-message/mcp-tools-results/mcp-ui-tools-results-async';

function filterToolsWithResourceUri(tools) {
  // eslint-disable-next-line no-underscore-dangle
  return tools?.filter(toolCall => toolCall.output?._meta?.ui?.resourceUri) ?? [];
}

/**
 * Renders MCPUIToolsResultsAsync when structData contains MCP UI tool responses.
 *
 * - If structData contains ui_tool_calls with a resourceUri, renders MCPUIToolsResultsAsync.
 * - Otherwise renders nothing.
 */
export function AppsRenderer({
  structData = null,
  onMCPLinkClick = noop,
  messageId,
  animate,
  visible = false,
  onAppsInitialized,
  isStreamingCompleted,
}) {
  const uiToolsResponses = useMemo(() => filterToolsWithResourceUri(structData?.ui_tool_calls), [structData]);

  useEffect(() => {
    if (!uiToolsResponses.length && isStreamingCompleted) {
      onAppsInitialized();
    }
  }, [onAppsInitialized, isStreamingCompleted, uiToolsResponses]);

  if (uiToolsResponses?.length) {
    return (
      <MCPUIToolsResultsAsync
        toolsResponses={uiToolsResponses}
        onLinkClick={onMCPLinkClick}
        messageId={messageId}
        animate={animate}
        visible={visible}
        onToolsInitialized={onAppsInitialized}
      />
    );
  }

  return null;
}

AppsRenderer.propTypes = {
  structData: PropTypes.shape({
    ui_tool_calls: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  onMCPLinkClick: PropTypes.func,
  messageId: PropTypes.string.isRequired,
  visible: PropTypes.bool,
};
